/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Container, Slide1, Slide2, Slide3, Slide4 } from './styles';

import man1 from '~/assets/tv/clear-aligners/man-1.png';
import woman1 from '~/assets/tv/clear-aligners/woman-1.png';
import woman2 from '~/assets/tv/clear-aligners/woman-2.png';

import man2 from '~/assets/tv/clear-aligners/man-2.png';
import woman3 from '~/assets/tv/clear-aligners/woman-3.png';
import clearCorrect from '~/assets/tv/clear-aligners/clear-correct-logo.svg';

import woman4 from '~/assets/tv/clear-aligners/woman-4.png';
import aligner from '~/assets/tv/clear-aligners/aligner.png';

import notice from '~/assets/tv/clear-aligners/notice.png';

interface IClearAligners {
  show: boolean;
  startAnim: boolean;
}

interface ISlide {
  slide: string;
  slideTime: number;
  beforeTime?: number;
  afterTime?: number;
  bgSlide?: string;
}

const ClearAligners: React.FC<IClearAligners> = ({ show, startAnim }) => {
  const [slideSelected, setSlideSelected] = useState({} as ISlide);
  const [showBefore, setShowBefore] = useState('');
  const [animSlideSelected, setAnimSlideSelected] = useState('');
  const [endAnimSlideSelected, setEndAnimSlideSelected] = useState('');

  const slides = useMemo<ISlide[]>(
    () => [
      { slide: 'Slide1', slideTime: 15000 },
      { slide: 'Slide2', slideTime: 10000 },
      { slide: 'Slide3', slideTime: 10000 },
      { slide: 'Slide4', slideTime: 30000 },
    ],
    []
  );

  const changeSlide = useCallback(
    (index) => {
      const { slide, slideTime } = slides[index];

      if (slides[index + 1] && slides[index + 1].beforeTime) {
        const nextSlide = slides[index + 1];
        if (nextSlide.beforeTime)
          setTimeout(() => {
            setShowBefore(nextSlide.slide);
            setAnimSlideSelected(nextSlide.slide);
          }, slideTime - nextSlide.beforeTime);
      }

      if (slides[index - 1] && slides[index - 1].afterTime) {
        const prevSlide = slides[index - 1];
        if (prevSlide.afterTime) {
          setEndAnimSlideSelected(prevSlide.slide);
          setSlideSelected(slides[index]);
          setTimeout(() => {
            setShowBefore('');
            setEndAnimSlideSelected('');
          }, prevSlide.afterTime);
        }
      } else {
        setSlideSelected(slides[index]);
      }
      setTimeout(() => {
        setAnimSlideSelected(slide);
        if (index + 1 < slides.length) {
          setTimeout(() => {
            changeSlide(index + 1);
          }, slideTime);
        } else {
          setTimeout(() => {
            setSlideSelected({} as ISlide);
          }, slideTime);
        }
      }, 100);
    },
    [slides]
  );

  useEffect(() => {
    if (show) {
      changeSlide(0);
    }
  }, [changeSlide, show]);

  return (
    <Container show={show} startAnim={startAnim}>
      <Slide1
        show={slideSelected.slide === 'Slide1'}
        startAnim={slideSelected.slide === 'Slide1'}
        notShow={slideSelected.slide !== 'Slide1'}
      >
        <div className="slide-container">
          <h2 className="mb-0">
            Transforme seu sorriso sem comprometer sua rotina.
          </h2>
          <h3 className="mb-0">
            Alinhadores transparentes: eficazes, discretos e confortáveis!
          </h3>
          <p className="tag tag-1 mb-0">Rápido</p>
          <p className="tag tag-2 mb-0">Estético</p>
          <p className="tag tag-3 mb-0">Confortável</p>
          <p className="tag tag-4 mb-0">Higiênico</p>
          <p className="tag tag-5 mb-0">Previsível</p>
          <img src={man1} alt="man" className="man" />
          <img src={woman1} alt="woman" className="woman-1" />
          <img src={woman2} alt="woman" className="woman-2" />
        </div>
      </Slide1>
      <Slide2
        show={slideSelected.slide === 'Slide2'}
        startAnim={slideSelected.slide === 'Slide2'}
      >
        <div className="slide-container">
          <p className="title">
            Tenha a liberdade e praticidade dos aparelhos transparentes
          </p>
          <img src={man2} alt="man" className="man" />
          <img src={woman3} alt="woman" className="woman" />
          <img
            src={clearCorrect}
            alt="Clear Correct"
            className="clear-correct"
          />
        </div>
      </Slide2>
      <Slide3
        show={slideSelected.slide === 'Slide3'}
        startAnim={slideSelected.slide === 'Slide3'}
      >
        <div className="slide-container">
          <p className="title">Você sabia que</p>
          <p className="content">
            Pessoas com dentes alinhados e brancos conseguem emprego mais rápido
            e <span>ganha até 30% mais</span>
          </p>
          <img src={woman4} alt="woman" className="woman" />
          <img src={aligner} alt="aligner" className="aligner" />
        </div>
      </Slide3>
      <Slide4
        show={slideSelected.slide === 'Slide4'}
        startAnim={slideSelected.slide === 'Slide4'}
      >
        <div className="slide-container">
          <img src={notice} alt="notice" className="notice" />
          <p className="source">Matéria: Exame</p>
          <p className="content">
            Um estudo recente realizado pelo King’s College de Londres aponta
            que, nas relações interpessoais, o bom estado dentário transmite as
            sensações de confiança e inteligência.
          </p>
        </div>
      </Slide4>
    </Container>
  );
};

export default ClearAligners;
